import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from '../services/navigation/navigation.service';
import { UserRightsService } from '../services/user-rights/user-rights.service';
import { LayoutService, ScreenSize } from './layout.service';
import { ToastrService } from 'ngx-toastr';
import { User } from '../models/User';
import { Endpoints } from '@huge-monorepo/portal/config';
import { GenericService } from '../services/generic/generic.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-layout-component',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements AfterViewInit {
  ScreenSize = ScreenSize;
  showSplitpane: boolean;
  collapse: boolean;
  selectedIndex = 0;
  impersonating = false;
  impersonatedUser: User;
  appPages: any = [];
  accesses: any;

  constructor(
    public layoutService: LayoutService,
    public navigationService: NavigationService,
    private auth: UserRightsService,
    private router: Router,
    private genericService: GenericService,
    private endpoints: Endpoints,
    private toastService: ToastrService,
    private cdr: ChangeDetectorRef,
  ) {}

  private isNewTabMode(): boolean {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('terminal'); // You can pass ?modalTab=true when opening the tab
  }

  ngAfterViewInit() {
    //this.initializeApp();
    setTimeout(() => {
      if (window.opener || this.isNewTabMode()) {
        this.showSplitpane = false; // Hide side navigation for new tab
      } else {
        this.showSplitpane = !!this.navigationService.IsSideNavOpen();
      }
    }, 1);
  }

  initializeApp() {
    this.impersonatedUser = this.auth.IsImpersonating();
    this.impersonating = this.impersonatedUser != null;
    const route = this.router.url;
    if (route.includes('/KeepAlive')) {
      this.buildKeepAlive();
    } else {
      this.buildHome();
    }
  }

  closeSideNav() {
    this.showSplitpane = false;
    this.navigationService.SideNavClosed();
  }

  onSizeChanged() {
    this.cdr.detectChanges();
    this.collapse = !this.collapse;
  }

  toggleSplitpane(ev: any) {
    // console.log("Layout service found split pane change", ev)

    this.showSplitpane = ev;
    if (this.showSplitpane) {
      this.navigationService.SideNavOpened();
    } else {
      this.navigationService.SideNavClosed();
    }
  }

  buildHome() {
    this.appPages = [
      {
        title: 'Home',
        url: '/Home',
        customIcon: false,
        icon: 'home',
        subPages: [],
      },
      {
        title: 'Modules',
        url: '',
        customIcon: false,
        icon: 'settings',
        subPages: [
          {
            title: 'Data Usage',
            url: '/Home/CDR',
            customIcon: true,
            icon: '../../assets/icon/barAndLineChart.svg',
          },
          {
            title: 'Keep Alive',
            url: '/KeepAlive',
            customIcon: true,
            icon: '../../assets/icon/mapLocation.svg',
          },
          {
            title: 'Router Management',
            url: '/Home/Mikrotik',
            customIcon: true,
            icon: '../../assets/icon/routerAndCable.svg',
          },
          {
            title: 'Transaction Monitoring',
            url: '/Home/Relay',
            customIcon: true,
            icon: '../../assets/icon/calendar.svg',
          },
          {
            title: 'Teltonika Management',
            url: '/Home/Teltonika',
            customIcon: true,
            icon: '../../assets/icon/teltonika.png',
          },
        ],
      },
      // Settings to be in each for mobile view
      {
        title: 'Settings',
        url: '/Home/Settings',
        customIcon: false,
        icon: 'settings',
        subPages: [],
        mobileOnly: true,
      },
      {
        title: 'Logout',
        customIcon: false,
        icon: 'log-out',
        subPages: [],
        func: () => {
          this.auth.Logout();
        },
      },
    ];
  }

  buildKeepAlive() {
    this.appPages = [
      {
        title: 'Home',
        url: '/Home',
        customIcon: false,
        icon: 'home',
        subPages: [],
      },
      {
        title: 'Dashboard',
        url: '/KeepAlive',
        customIcon: true,
        icon: '../../assets/icon/mapLocation.svg',
        subPages: [],
      },
      {
        title: 'Map',
        url: '/KeepAlive/Map',
        customIcon: true,
        icon: '../../assets/icon/map.svg',
        subPages: [],
      },
      {
        title: 'Devices',
        url: '',
        customIcon: true,
        icon: '',
        subPages: [],
      },
      // Settings to be in each for mobile view
      {
        title: 'Settings',
        url: '/Home/Settings',
        customIcon: false,
        icon: 'settings',
        subPages: [],
        mobileOnly: true,
      },
      {
        title: 'Logout',
        customIcon: false,
        icon: 'log-out',
        subPages: [],
        func: () => {
          this.auth.Logout();
        },
      },
    ];

    if (this.auth.HasCDRAccess()) {
      this.appPages[3].subPages.push({
        title: 'CDR Devices',
        url: '/KeepAlive/Devices/CDR',
        customIcon: true,
        icon: '../../assets/icon/devices.svg',
      });

      this.appPages.splice(
        this.appPages.length - 2, // To place it before mobile settings and logout but underneath everything else
        0,
        {
          title: 'Usage Alerts',
          url: '/KeepAlive/Alerts',
          customIcon: true,
          icon: '../../assets/icon/alerts.svg',
          subPages: [],
        },
      );
    }

    if (this.auth.HasKeepAliveAccess()) {
      this.appPages[3].subPages.push({
        title: 'Keep Alive Devices',
        url: '/KeepAlive/Devices/KeepAlive',
        customIcon: true,
        icon: '../../assets/icon/devices.svg',
      });

      this.appPages.splice(
        this.appPages.length - 2, // To place it before mobile settings and logout but underneath everything else
        0,
        {
          title: 'Ringfence Alerts',
          url: '/KeepAlive/DeviceRingfenceLogs',
          customIcon: true,
          icon: '../../assets/icon/logs.svg',
          subPages: [],
        },
      );
    }
  }

  stopImpersonation() {
    // TODO: Add actual user ID
    this.genericService.DELETE(this.endpoints.STOP_IMPERSONATING).subscribe(() => {
      // console.log(results);
      this.auth.StopImpersonation();
      this.toastService.success('You have stopped the impersonation', 'Impersonation stopped', { timeOut: 8 });
    });
  }
}
